<div class="flex grid">
    @for (item of fecYearProvider.getList(); track $index;) {
        <app-fec-year
            [fecYear] = "item"
        >
        </app-fec-year>
    }
    <app-new-fec-year></app-new-fec-year>
</div>
